import type { ReactNode } from 'react';

import { I18nextProvider } from 'react-i18next';

import i18n from '@/shared/lib/i18n';

interface I18nProviderProps {
  readonly children: ReactNode;
}

/**
 * Provider de internacionalização.
 *
 * Usa a instância i18n configurada em `src/shared/lib/i18n.ts` com
 * os namespaces de todas as features registrados.
 *
 * Para adicionar um novo namespace (nova feature), edite `src/shared/lib/i18n.ts`.
 */
export function I18nProvider({ children }: I18nProviderProps) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
